// dependencies
import { useQuery } from "@tanstack/react-query";
import type { UseQueryOptions } from "@tanstack/react-query";

// api
import {
	type UserDescendantsData,
	fetchIsUserInChainOfCommand,
	fetchMembersUserIsGroupAdminOf,
	fetchUserDescendants,
} from "../../services";

export interface IGroupAdminPermissionsParams {
	goals?: boolean;
	feedback?: boolean;
	reviews?: boolean;
}

export const useUserDescendants = (userID: string, options?: Partial<UseQueryOptions<UserDescendantsData>>) => {
	const query = useQuery<UserDescendantsData>({
		queryKey: ["UserDescendants", userID],
		queryFn: () => fetchUserDescendants(),
		meta: {
			errorMessage: "There was an error getting chain of command list.",
		},
		...options,
	});

	return query;
};

export const useIsUserInChainOfCommand = (userBeingViewedId: string, disabled = false) => {
	const query = useQuery({
		queryKey: ["UserDescendants", userBeingViewedId],
		queryFn: async () => await fetchIsUserInChainOfCommand(userBeingViewedId),
		meta: {
			errorMessage: "There was an error getting if user is in chain of command.",
		},
		enabled: !disabled,
	});

	return query;
};

export const useMembersUserIsGroupAdminOf = (params: IGroupAdminPermissionsParams) => {
	const query = useQuery({
		queryKey: ["userGroupAdminMembers", params],
		queryFn: async () => await fetchMembersUserIsGroupAdminOf(params),
		meta: {
			errorMessage: "There was an error getting members user is group admin of.",
		},
	});

	return query;
};
